<div class="product-detail-container">
  <!-- Header with Action Buttons -->
  <div class="header-section">
    <div class="header-content">
      <h1 class="page-title">{{ "goods.product_review.detail.approval_title" | translate }}</h1>
      <div class="action-buttons">
        <button
          pButton
          type="button"
          [label]="'goods.product_review.detail.actions.approve' | translate"
          class="p-button-primary pass-button"
          (click)="onPass()"
        ></button>
        <button
          pButton
          type="button"
          [label]="'goods.product_review.detail.actions.reject' | translate"
          class="p-button-warning turn-down-button"
          (click)="onTurnDown()"
        ></button>
        <button
          pButton
          type="button"
          [label]="'goods.product_review.detail.actions.back' | translate"
          class="p-button-secondary return-button"
          (click)="onReturn()"
        ></button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  @if (isLoading()) {
  <div class="loading-container">
    <p>{{ "goods.product_review.detail.messages.loading" | translate }}</p>
  </div>
  }

  <!-- Error State -->
  @if (error() && !isLoading()) {
  <div class="error-container">
    <p class="error-message">{{ error() }}</p>
      <button
        pButton
        type="button"
        [label]="'goods.product_review.detail.actions.retry' | translate"
        class="p-button-secondary"
        (click)="loadProductDetail()"
      ></button>
  </div>
  }

  <!-- Product Details Content -->
  @if (productDetail() && !isLoading()) {
  <div class="detail-content">
    <!-- Basic Information Section -->
    <div class="detail-section">
      <div class="section-header">
        <div class="section-title-bar"></div>
        <h2 class="section-title">{{ "goods.product_review.detail.sections.basic_information" | translate }}</h2>
      </div>
      <div class="section-content">
        <div class="info-grid">
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.sku_name" | translate }}</div>
            <div class="info-value">{{ productDetail()?.skuName }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.sku_code" | translate }}</div>
            <div class="info-value">{{ productDetail()?.skuCode }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_name" | translate }}</div>
            <div class="info-value">{{ productDetail()?.productName }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_code" | translate }}</div>
            <div class="info-value">{{ productDetail()?.productCode }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_category" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.productCategories }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_brand" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.productBrand }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.material_name" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.materialName }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.display_flag" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.showFlag === 1 ? ("goods.product_review.detail.values.display" | translate) : ("goods.product_review.detail.values.hide" | translate) }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.status" | translate }}</div>
            <div class="info-value">
              {{ getStatusLabel(productDetail()?.status) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SKU Attributes Section -->
    <div class="detail-section">
      <div class="section-header">
        <div class="section-title-bar"></div>
        <h2 class="section-title">{{ "goods.product_review.detail.sections.sku_attributes" | translate }}</h2>
      </div>
      <div class="section-content">
        <div class="info-grid">
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_weight" | translate }}</div>
            <div class="info-value">{{ productDetail()?.productWeight }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_length" | translate }}</div>
            <div class="info-value">{{ productDetail()?.productLength }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_width" | translate }}</div>
            <div class="info-value">{{ productDetail()?.productWidth }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.product_height" | translate }}</div>
            <div class="info-value">{{ productDetail()?.productHeight }}</div>
          </div>

          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.package_width" | translate }}</div>
            <div class="info-value">{{ productDetail()?.productWeight }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.package_length" | translate }}</div>
            <div class="info-value">{{ productDetail()?.productLength }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.package_height" | translate }}</div>
            <div class="info-value">{{ productDetail()?.productWidth }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- SKU Price Section -->
    <div class="detail-section">
      <div class="section-header">
        <div class="section-title-bar"></div>
        <h2 class="section-title">{{ "goods.product_review.detail.sections.sku_prices" | translate }}</h2>
      </div>
      <div class="section-content">
        <div class="info-grid">
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.cost_price" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.costPrice | number : "1.2-2" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.sales_price" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.salesPrice | number : "1.2-2" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.promotional_price" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.marketingPrice | number : "1.2-2" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.market_price" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.marketPrice | number : "1.2-2" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.distribution_price" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.distributionPrice | number : "1.2-2" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.wholesale_price" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.wholesalePrice | number : "1.2-2" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.clearance_price" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.settlementPrice | number : "1.2-2" }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.promotion_price" | translate }}</div>
            <div class="info-value">
              {{
                productDetail()?.internalApportionmentPrice | number : "1.2-2"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SKU Attributes Section -->
    @if ((productDetail()?.skuAttributeList?.length ?? 0) > 0) {
    <div class="detail-section">
      <div class="section-header">
        <div class="section-title-bar"></div>
        <h2 class="section-title">{{ "goods.product_review.detail.sections.sku_attributes" | translate }}</h2>
      </div>
      <div class="section-content">
        <div class="info-grid">
          @for (attr of productDetail()?.skuAttributeList || []; track attr?.id)
          {
          <div class="info-row">
            <div class="info-label">{{ attr?.name || "Attribute" }}</div>
            <div class="info-value">{{ attr?.value || "N/A" }}</div>
          </div>
          }
        </div>
      </div>
    </div>
    }

    <!-- Other Attributes Section -->
    @if ((productDetail()?.otherAttributeList?.length ?? 0) > 0) {
    <div class="detail-section">
      <div class="section-header">
        <div class="section-title-bar"></div>
        <h2 class="section-title">{{ "goods.product_review.detail.sections.other_attributes" | translate }}</h2>
      </div>
      <div class="section-content">
        <div class="info-grid">
          @for (attr of productDetail()?.otherAttributeList || []; track
          attr?.id) {
          <div class="info-row">
            <div class="info-label">{{ attr?.name || "Attribute" }}</div>
            <div class="info-value">{{ attr?.value || "N/A" }}</div>
          </div>
          }
        </div>
      </div>
    </div>
    }

    <!-- Package Details Section -->
    @if ((productDetail()?.skuDetailList?.length ?? 0) > 0) {
    <div class="detail-section">
      <div class="section-header">
        <div class="section-title-bar"></div>
        <h2 class="section-title">{{ "goods.product_review.detail.sections.package_details" | translate }}</h2>
      </div>
      <div class="section-content">
        <div class="info-grid">
          @for (detail of productDetail()?.skuDetailList || []; track
          detail?.id) {
          <div class="info-row">
            <div class="info-label">
              {{ detail?.skuName || ("goods.product_review.detail.fields.package_item" | translate) }}
            </div>
            <div class="info-value">
              {{ detail?.quantity || 1 }} x {{ detail?.skuCode || ("goods.product_review.detail.values.na" | translate) }}
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    }

    <!-- Product Assets Section -->
    <div class="detail-section">
      <div class="section-header">
        <div class="section-title-bar"></div>
        <h2 class="section-title">{{ "goods.product_review.detail.sections.product_assets" | translate }}</h2>
      </div>
      <div class="section-content">
        <div class="materials-grid">
          <div class="material-row">
            <div class="material-label">{{ "goods.product_review.detail.fields.asset_name" | translate }}</div>
            <div class="material-content">
              <div class="asset-name-value">
                {{ productDetail()?.productName || ("goods.product_review.detail.values.product_asset_collection" | translate) }}
              </div>
            </div>
          </div>
          <div class="material-row">
            <div class="material-label">{{ "goods.product_review.detail.fields.main_images" | translate }}</div>
            <div class="material-content">
              <div class="image-placeholder">
                <img
                  [src]="productDetail()?.mainImage"
                  alt="Main Image"
                  class="material-image"
                />
              </div>
              <div class="image-placeholder">
                <img
                  [src]="productDetail()?.mainImage"
                  alt="Main Image"
                  class="material-image"
                />
              </div>
            </div>
          </div>
          <div class="material-row">
            <div class="material-label">{{ "goods.product_review.detail.fields.detail_images" | translate }}</div>
            <div class="material-content">
              <div class="image-placeholder">
                <img
                  [src]="productDetail()?.detailedImage"
                  alt="Detailed Image"
                  class="material-image"
                />
              </div>
              <div class="image-placeholder">
                <img
                  [src]="productDetail()?.detailedImage"
                  alt="Detailed Image"
                  class="material-image"
                />
              </div>
            </div>
          </div>
          <div class="material-row">
            <div class="material-label">{{ "goods.product_review.detail.fields.product_description" | translate }}</div>
            <div class="material-content">
              <div class="description-content">
                <p class="description-text">
                  {{
                    productDetail()?.productDescription ||
                      ("goods.product_review.detail.values.no_description" | translate)
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Approval Section -->
    <div class="detail-section">
      <div class="section-header">
        <div class="section-title-bar"></div>
        <h2 class="section-title">{{ "goods.product_review.detail.sections.approval_information" | translate }}</h2>
      </div>
      <div class="section-content">
        <div class="info-grid">
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.submitted_by" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.submittedBy || ("goods.product_review.detail.values.system" | translate) }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.submission_date" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.auditCommitDate || ("goods.product_review.detail.values.na" | translate) }}
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ "goods.product_review.detail.fields.audit_comment" | translate }}</div>
            <div class="info-value">
              {{ productDetail()?.auditComment || ("goods.product_review.detail.values.no_comment" | translate) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Audit Modal -->
  <p-dialog
    [visible]="showModal()"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="false"
    [style]="{ width: '500px' }"
    (onHide)="onModalCancel()"
  >
    <ng-template pTemplate="header">
      <div class="modal-header">
        <h3 class="modal-title">{{ modalTitle() }}</h3>
        <button type="button" class="modal-close-btn" (click)="onModalCancel()">
          ×
        </button>
      </div>
    </ng-template>

    <ng-template pTemplate="content">
      <div class="modal-content">
        <div class="comment-section">
          <label class="comment-label">{{ "goods.product_review.detail.messages.enter_comment" | translate }}</label>
          <div class="textarea-container">
            <textarea
              pTextarea
              [rows]="4"
              [cols]="50"
              [placeholder]="'goods.product_review.detail.messages.enter_comment_placeholder' | translate"
              [value]="auditComment()"
              (input)="onCommentChange($event)"
              class="audit-comment-textarea"
            >
            </textarea>
            <div class="character-counter">
              {{ getCommentLength() }}/{{ maxCommentLength }}
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <div class="modal-footer">
        <button
          pButton
          type="button"
          [label]="'goods.product_review.detail.actions.cancel' | translate"
          class="p-button-secondary modal-cancel-btn"
          (click)="onModalCancel()"
        ></button>
        <button
          pButton
          type="button"
          [label]="'goods.product_review.detail.actions.sure' | translate"
          class="p-button-primary modal-confirm-btn"
          (click)="onModalConfirm()"
        ></button>
      </div>
    </ng-template>
  </p-dialog>
</div>
